import fillCrudMetadataGaps from '../../fillCrudMetadataGaps';
import authorization from '../../util/authorization';
export default fillCrudMetadataGaps({
  label: 'Acompanhemento de Reservas Similares',
  name: 'SimilarReservationTrack',
  deletable: false,
  dynamoDB: {
    tableName: 'SpearSimilarReservationTrack',
    /** este filtro só deveria conter as reservas com erro, por isso não precisamos filtrar pelo appsync quando pesquisar com este index */
    indexName: 'tenantId-problemDetectedDate-index',
    indexedProp: 'problemDetectedDate'
  },
  authorization: authorization('clientConsultant', 'master'),
  columnNames: ['id', 'tenantId', 'startDate', 'endDate', 'hotelId', 'clientId', 'clientName', 'reservationCounter', 'reservations', 'problemDetectedDate'],
  fields: [{
    name: 'id',
    label: 'Id',
    type: 'text',
    id: true
  }, {
    name: 'tenantId',
    label: 'Id do tenant',
    type: 'text'
  }, {
    name: 'startDate',
    label: 'Data de check-in',
    type: 'datetime'
  }, {
    name: 'endDate',
    label: 'Data de check-out',
    type: 'datetime'
  }, {
    name: 'hotelId',
    label: 'Id do hotel',
    type: 'text'
  }, {
    name: 'clientId',
    label: 'Id do cliente',
    type: 'text'
  }, {
    name: 'clientName',
    label: 'Nome do cliente',
    type: 'text'
  }, {
    name: 'reservationCounter',
    label: 'Contador de reservas',
    type: 'int'
  }, {
    name: 'reservations',
    label: 'Reservas',
    type: 'textarray'
  }, {
    name: 'problemDetectedDate',
    label: 'Data da detecção do problema',
    type: 'datetime'
  }],
  filter: [{
    field: 'problemDetectedDate',
    op: 'ge'
  }, {
    field: 'problemDetectedDate',
    op: 'le'
  }]
});